import './blog-grid.scss';
import { findAll, onBlockRender, once } from '../../global/utils/acf-preview';

// Blog Grid: Solution filter tabs + "Load more" batching. In the "All" view
// cards reveal in batches of `step`; filtering to a category shows all of that
// category. Figma 268-9053.
//
// The filter bar and load-more button are siblings of the grid inside the same
// block, so they are looked up from the block's root section rather than the
// document. That keeps two grids on one page (or one editor canvas) apart.
function initBlogGrid( grid: HTMLElement ): void {
	if ( ! once( grid, 'BlogGrid' ) ) {
		return;
	}
	const scope: ParentNode = grid.closest<HTMLElement>( '.blog-grid-block' ) ?? grid.ownerDocument;

	const items = Array.from( grid.querySelectorAll<HTMLElement>( '.blog-grid__item' ) );
	const filterBar = scope.querySelector<HTMLElement>( '[data-blog-filter]' );
	const loadMore = scope.querySelector<HTMLButtonElement>( '[data-load-more]' );
	const step = loadMore ? parseInt( loadMore.dataset.step || '6', 10 ) : items.length;

	let activeFilter = 'all';
	let visible = step;

	const render = (): void => {
		let matchCount = 0;
		items.forEach( ( item ) => {
			const matches = activeFilter === 'all' || item.dataset.category === activeFilter;
			// In the "All" view honour the batch limit; a category shows all matches.
			const show = matches && ( activeFilter !== 'all' || matchCount < visible );
			if ( matches ) {
				matchCount += 1;
			}
			item.classList.toggle( 'is-hidden', ! show );
		} );
		if ( loadMore ) {
			loadMore.style.display = activeFilter === 'all' && matchCount > visible ? '' : 'none';
		}
	};

	if ( filterBar ) {
		const tabs = Array.from( filterBar.querySelectorAll<HTMLElement>( '.blog-filter__tab' ) );
		tabs.forEach( ( tab ) => {
			tab.addEventListener( 'click', () => {
				tabs.forEach( ( t ) => t.classList.remove( 'is-active' ) );
				tab.classList.add( 'is-active' );
				activeFilter = tab.dataset.filter || 'all';
				visible = step;
				render();
			} );
		} );
	}

	if ( loadMore ) {
		loadMore.addEventListener( 'click', () => {
			visible += step;
			render();
		} );
	}

	render();
}

onBlockRender( 'blog-grid', ( root ) => {
	findAll<HTMLElement>( root, '[data-blog-grid]' ).forEach( initBlogGrid );
} );
